const calendarEventTextRegex = /^text-[0-9]{4}-[0-9]{2}-[0-9]{2}/;
const calendarEventPhotoRegex = /^photo-[0-9]{4}-[0-9]{2}-[0-9]{2}/;
const optionalSlotRegex = /^optional-/;
const clonedSlotRegex = /^.*:/;

function isCalendarEventTextSlot(slotID) {
  return slotID.match(calendarEventTextRegex);
}

function isCalendarEventPhotoSlot(slotID) {
  return slotID.match(calendarEventPhotoRegex);
}

function isOptionalSlot(slotID) {
  return slotID.match(optionalSlotRegex);
}

function isClonedSlot(slotID) {
  return slotID.match(clonedSlotRegex);
}

export { isCalendarEventTextSlot, isCalendarEventPhotoSlot, isOptionalSlot, isClonedSlot };
